var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled, css } from '../theme-provider';
import { useTableContext } from './table';
export const StyledTableHeader = styled.th.withConfig({ displayName: "StyledTableHeader", componentId: "sc-ubv4p3" }) `display:table-cell;background-color:${({ theme, emphasized }) => theme.colors.background[emphasized ? 'tertiary' : 'primary']};color:${({ theme }) => theme.colors.content.primary};text-align:start;padding:${({ theme }) => theme.size.static200} ${({ theme }) => theme.size.static100};border-bottom:${({ theme }) => theme.size.border.heavy} solid ${({ theme }) => theme.colors.border.divider};word-break:break-word;&[scope='row']{border-bottom-width:${({ theme }) => theme.size.border.light};}${({ fixedHeaderColumn, solidHeaderColumn, theme }) => {
    const solidBorder = `border-inline-end: ${theme.size.border.light} solid
				${theme.colors.border.divider};`;
    const fadeOut = `mask: linear-gradient(black 0 0)
						${theme.direction === 'rtl' ? 'right' : 'left'},
					linear-gradient(
							${theme.direction === 'rtl' ? '270deg' : '90deg'},
							black,
							transparent
						)
						${theme.direction === 'rtl' ? 'left' : 'right'};
				mask-size:
					calc(100% - ${theme.size.static350}) 100%,
					${theme.size.static350} 100%;
				mask-repeat: no-repeat;`;
    return (fixedHeaderColumn &&
        css `
				&[scope='row']:first-of-type {
					position: sticky;
					${theme.direction === 'rtl' ? 'right: 0;' : 'left: 0;'}
					${solidHeaderColumn ? solidBorder : fadeOut}
				}
				/* The content in TableHeader will always wrap when it overflows. The width calculation
			leaves extra space, ensuring that column content is smoothly hidden when scrolling. */
				overflow-wrap: anywhere;
				& > * {
					max-width: calc(100% - 4ch);
				}
			`);
}}`;
export const TableHeader = (_a) => {
    var { children, emphasized = false } = _a, rest = __rest(_a, ["children", "emphasized"]);
    const headerRef = React.useRef(null);
    const { showNavigation, tableHeadersRef, fixedHeaderColumn, solidHeaderColumn, } = useTableContext();
    React.useEffect(() => {
        const currentHeader = headerRef.current;
        if (!currentHeader) {
            return;
        }
        if (fixedHeaderColumn && currentHeader.matches(':first-child')) {
            // if it is the first th in the tr and fixedHeaderColumn is set, set scope to row
            currentHeader.setAttribute('scope', 'row');
        }
        else if (currentHeader.closest('thead')) {
            // set scope to col for all other th in thead
            currentHeader.setAttribute('scope', 'col');
        }
        else if (currentHeader.closest('tbody')) {
            // set scope to row for all other th in tbody
            currentHeader.setAttribute('scope', 'row');
        }
        else {
            currentHeader.setAttribute('scope', '');
        }
    }, [fixedHeaderColumn]);
    React.useEffect(() => {
        const currentHeader = headerRef.current;
        if (!currentHeader)
            return;
        const tableHeaders = tableHeadersRef === null || tableHeadersRef === void 0 ? void 0 : tableHeadersRef.current;
        if (!tableHeaders)
            return;
        const isCurrentHeaderInsideThead = currentHeader.closest('thead');
        const isFirstHeader = !currentHeader.previousElementSibling;
        /*	Push the table header ref into the tableHeadersRef array if it is inside the thead and has children.
            This is needed in order to prevent the empty th (used when the th with scope "row" are needed) as well as the th with scope "row" from being counted*/
        if (isCurrentHeaderInsideThead && !(isFirstHeader && fixedHeaderColumn)) {
            tableHeaders.push(currentHeader);
        }
    }, [tableHeadersRef, fixedHeaderColumn]);
    return (React.createElement(StyledTableHeader, Object.assign({ emphasized: emphasized, fixedHeaderColumn: fixedHeaderColumn, solidHeaderColumn: solidHeaderColumn, ref: headerRef, showNavigation: showNavigation }, rest), children));
};
